import React, { useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import PermissionHOC from 'src/hoc/PermissionHOC';
import MenuLinkComponent from './MenuLinkComponent';
import MenuBandageComponent from './MenuBandageComponent';
import LinkComponent from '../LinkComponent';

const MenuDropdownComponent = ({
    faIcon,
    title,
    bandage,
    items,
}) => {
    const sideBarDropDownRef = useRef(null);

    const menuClickHandler = useCallback(() => {
        const jQuery = window.$;

        // hide all side bar sub menu
        jQuery('.sidebar-submenu').slideUp(200);
        const target = jQuery(sideBarDropDownRef.current);

        if (target.parent().hasClass('active')) {
            jQuery('.sidebar-dropdown').removeClass('active');

            target.parent().removeClass('active');
        }
        else {
            jQuery('.sidebar-dropdown').removeClass('active');

            target.next('.sidebar-submenu').slideDown(200);
            target.parent().addClass('active');
        }
    }, []);

    return (
        <li
            className="sidebar-dropdown"
        >
            <LinkComponent
                ref={sideBarDropDownRef}
                onClick={menuClickHandler}
            >
                <i className={`fas ${faIcon}`} />
                <span>{title}</span>
                <MenuBandageComponent
                    title={bandage.title}
                    faIcon={bandage.faIcon}
                />
            </LinkComponent>
            <div className="sidebar-submenu">
                <ul>
                    {items.map((item) => (
                        <PermissionHOC
                            scope={item.scope}
                            key={item.title}
                        >
                            <MenuLinkComponent
                                key={item.title}
                                title={item.title}
                                link={item.link}
                                bandage={item.bandage}
                            />
                        </PermissionHOC>
                    ))}
                </ul>
            </div>
        </li>
    );
};

MenuDropdownComponent.propTypes = {
    bandage: PropTypes.shape({
        faIcon: PropTypes.string,
        title: PropTypes.string,
    }),
    faIcon: PropTypes.string,
    // eslint-disable-next-line react/forbid-prop-types
    items: PropTypes.array,
    title: PropTypes.string,
};

MenuDropdownComponent.defaultProps = {
    bandage: {
        faIcon: '',
        title: '',
    },
    faIcon: '',
    items: [],
    title: '',
};

export default MenuDropdownComponent;
